import { useEffect } from 'react';

const useViewportCSS = () => {
  useEffect(() => {
    // Only run on client side
    if (typeof window === 'undefined') return;

    const updateViewportCSS = () => {
      const vh = window.innerHeight * 0.01;
      const vw = window.innerWidth * 0.01;
      
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      document.documentElement.style.setProperty('--vw', `${vw}px`);
      document.documentElement.style.setProperty('--window-height', `${window.innerHeight}px`);
      document.documentElement.style.setProperty('--window-width', `${window.innerWidth}px`);
    };

    // Set initial values
    updateViewportCSS();

    // Add event listener with debouncing
    let timeoutId;
    const debouncedUpdate = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(updateViewportCSS, 100);
    };

    window.addEventListener('resize', debouncedUpdate);
    window.addEventListener('orientationchange', debouncedUpdate);

    return () => {
      window.removeEventListener('resize', debouncedUpdate);
      window.removeEventListener('orientationchange', debouncedUpdate);
      clearTimeout(timeoutId);
    };
  }, []);
};

export default useViewportCSS;
